import React, { Component } from "react";
import SolicitudesService from "../../../services/solicitudes/SolicitudesService";
import { trackPromise } from 'react-promise-tracker';
import Popup from "react-popup";
import DataTable from 'react-data-table-component';
import $ from "jquery";
import Switch from "react-switch";

export default class SeleccionTarjetaSwitch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaTC: undefined,
      lista: [],
      listaAlertas: [],
      listaAlertasTarjetas: []
    };
  }
  componentDidMount() { 
    this.setState({ listaAlertasTarjetas: this.obtenerListadoAlertasTarjetas() });
    this.setState({ listaAlertas: this.obtenerListadoAlertas() });
  }
  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  buscar = () => {

    var respuesta = [];
    trackPromise(
      SolicitudesService.getAlertasTarjetas(this.props.telefono)
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          //console.log(jsonData)
          if (jsonData.codigoRetorno === "0") {
            for (var i = 0; i < jsonData.resultadoTarjetas.length; i++) {
              respuesta.push({
                id: i + 1,
                marca: jsonData.resultadoTarjetas[i].marca,
                nroTarjeta: jsonData.resultadoTarjetas[i].nroTarjeta,
                suscribir: false,
                adicional: false,
              });
            }
            this.setState({ listaTC: respuesta });
          }
          else {
            this.setState({ listaTC: [] });
            Popup.queue(this.notifiPopup("Info", "No tiene Tarjetas que mostrar"));
            return;
          }
        }

        ));

  }

  getColumnTarjeta() {
    return [
      {
        name: "Marca",
        selector: row => row.marca,
      },
      {
        name: "Tarjeta",
        selector: row => row.nroTarjeta,
      },
      {
        name: "Estado Principal",
        cell: (row) => (
          <Switch id={row.identificador}
            onChange={this.props.handleChangeSwitchTarjetas}
            checked={row.estadoAlerta == 'A'}
            height={15} width={40} uncheckedIcon={false}
            checkedIcon={false} handleDiameter={22} className="react-switch"
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            onColor="#007b33" />
        ),
      //  width: "100px",
      },
      {
        name: "Estado Adicional",
        cell: (row) => (
          <Switch id={row.identificador}
            onChange={this.handleChangeSwitch}
            checked={row.estadoAlerta == 'A'}
            height={15} width={40} uncheckedIcon={false}
            checkedIcon={false} handleDiameter={22} className="react-switch"
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            onColor="#007b33" />
        ),
       // width: "100px",
      }
    ]
  }

  selGrupoEvt = (e) => {
    this.preSele = e.currentTarget;

    var respuesta = [];
    var res = false;
    for (var i = 0; i < this.state.listaTC.length; i++) {

      if ("radio_" + this.state.listaTC[i].id === this.preSele.id) {
        var susc = this.state.listaTC[i].suscribir
        if (susc === false)
          res = true;
        respuesta.push({
          id: i + 1,
          marca: this.state.listaTC[i].marca,
          nroTarjeta: this.state.listaTC[i].nroTarjeta,
          suscribir: res,
          adicional: this.state.listaTC[i].adicional,
        });
      }
      else {
        respuesta.push({
          id: i + 1,
          marca: this.state.listaTC[i].marca,
          nroTarjeta: this.state.listaTC[i].nroTarjeta,
          suscribir: this.state.listaTC[i].suscribir,
          adicional: this.state.listaTC[i].adicional,
        });
      }
    }
    this.setState({ listaTC: respuesta });
     this.props.rptSuscribir(this.preSele.value, res);
  
  };
  enableNext() {
    // this.checkGrilla();
  }

  checkGrilla(valor) {

    if (this.preSele !== undefined) {
      //console.log($("#" + this.preSele.id).prop("checked"));
      $("#" + this.preSele.id).prop("checked", valor);
    }

  }


  adiGrupoEvt = (e) => {
    this.adiSele = e.currentTarget;
    var respuesta = [];
    var res = false;
    for (var i = 0; i < this.state.listaTC.length; i++) {
      if ("radio_" + this.state.listaTC[i].nroTarjeta === this.adiSele.id) {
        var susc = this.state.listaTC[i].adicional
        if (susc === false)
          res = true;
        respuesta.push({
          id: i + 1,
          marca: this.state.listaTC[i].marca,
          nroTarjeta: this.state.listaTC[i].nroTarjeta,
          suscribir: this.state.listaTC[i].suscribir,
          adicional: res,
        });
      }
      else {
        respuesta.push({
          id: i + 1,
          marca: this.state.listaTC[i].marca,
          nroTarjeta: this.state.listaTC[i].nroTarjeta,
          suscribir: this.state.listaTC[i].suscribir,
          adicional: this.state.listaTC[i].adicional,
        });
      }
    }
    this.setState({ listaTC: respuesta });
    
    this.props.rptAdicional(this.adiSele.value, res);
    //this.enableNextAdi();
  };
  enableNextAdi() {
 //   this.checkGrillaAdi();
  }

  checkGrillaAdi(valor) {

    if (this.adiSele !== undefined) {
//console.log("SELECCIONADO ADICIONAL "+this.adiSele.id)
      $("#" + this.adiSele.id).prop("checked", valor);
    }

  }

  handleChange(e, it) {
    var respuesta = this.state.listaTC;
    for (var i = 0; i < this.state.listaTC.length; i++) {
      var susc = this.state.listaTC[i].suscribir
      var res = false;
      if (it.id === this.state.listaTC[i].id && susc === false)
        res = true;
      respuesta.push({
        id: i + 1,
        marca: this.state.listaTC[i].marca,
        nroTarjeta: this.state.listaTC[i].nroTarjeta,
        suscribir: res,
        adicional: this.state.listaTC[i].adicional,
      });
    }
    this.setState({ listaTC: respuesta });
    //console.log(respuesta)
  }
      /**
 * HABILITAR / INHABILITAR ALERTAS TARJETAS
 */

      /* handleChangeSwitchTarjetas = (checked, event, id) => {
        for (var i = 0; i < this.state.listaAlertas.length; i++) {
          if (this.state.listaAlertas[i].identificador === id) {
            if (checked === true) {
              this.setState({
                msg_up: "Desea activar la notificación para la tarjeta seleccionada?", check: true, idSelect: id,
                estadoAlerta: "A",
                tipoAlerta: this.state.listaAlertas[i].tipo,
                numeroAlerta: this.state.listaAlertas[i].numero,
                mostrarConfirmar: true
              });
            } else {
              this.setState({
                msg_up: "Desea desactivar la notificación para la tarjeta seleccionada?", check: false, idSelect: id,
                estadoAlerta: "I",
                tipoAlerta: this.state.listaAlertas[i].tipo,
                numeroAlerta: this.state.listaAlertas[i].numero,
                mostrarConfirmar: true
              })
            }
            break;
          }
        }
    
    
        if (checked === true) {
          this.setState({ msg_up: "Desea activar la notificación?", titleMensaje: "Confirmar Operación" });
    
        } else {
          this.setState({ msg_up: "Desea desactivar la notificación?", titleMensaje: "Confirmar Operación" });
        }
        this.modalCtrlConfirmSwitch.click();
      }*/
       //obtener listado de alertas de tarjetas suscriptas
  obtenerListadoAlertasTarjetas = () => {

    trackPromise(
      SolicitudesService.obtenerListadoAlertasTarjetas().then((response) => {
        var respuesta = [];
        var data = JSON.stringify(response.data);
        var jsonData = JSON.parse(data);

        if (jsonData.codigoRetorno === "0") {
          for (var i = 0; i < jsonData.resultado.length; i++) {
            respuesta.push({
              numeroCuenta: jsonData.resultado[i].numeroCuenta,
              adicional: jsonData.resultado[i].adicional
            });
          }
        }
        this.setState({ listaAlertasTarjetas: respuesta });
      })
    ).catch(function (error) {
      console.log(error);
    });
  };
  obtenerListadoAlertas = () => {
    sessionStorage.setItem("mostrarNumero", false);
    trackPromise(
      SolicitudesService.obtenerListadoAlertas().then((response) => {
        var respuesta = [];
        var data = JSON.stringify(response.data);
        var jsonData = JSON.parse(data);
        if (jsonData.resultado.length > 0) {

         
        
        }
        if (jsonData.codigoRetorno === "0") {
          for (var i = 0; i < jsonData.resultado.length; i++) {
            respuesta.push({
              descripcion: jsonData.resultado[i].descripcion,
              tipo: jsonData.resultado[i].tipo,
              costo: jsonData.resultado[i].costo,
              nroReceptor: jsonData.resultado[i].telefono,
              numero: jsonData.resultado[i].numero,
              identificador: jsonData.resultado[i].identificador,
              estadoAlerta: jsonData.resultado[i].estado,
              identificador: jsonData.resultado[i].identificador,
              label: jsonData.resultado[i].descripcion
            });
          }

        }

        this.setState({ listaAlertas: respuesta });
       
      })
    ).catch(function (error) {
      console.log(error);
    });
  };

  render() {
    var tarjetas = []
    if (this.state.listaTC === undefined)
      this.buscar()
    else
      tarjetas = this.state.listaTC
    return (
      <div className="row">
        
       
        <div className="col-md-12 card-body" style={{ marginBottom: "0px" }}>
         
           
           <div className="table-responsive">
            <DataTable
            noHeader={true}
              columns={this.getColumnTarjeta()}
              data={this.state.listaTC}
              dense={true}
              striped={true}
              responsive={true}
              noDataComponent="no hay registros para mostrar" />
          </div>
        </div>
      </div>
    );
  }
}
